<template>
  <div class="main-layout">
    <router-view :key="$route.path" v-on="$listeners"/>
  </div>
</template>

<script>
export default {
  name: "MainLayout",
}
</script>

<style lang="scss">
@import "MainLayout";
</style>

